
<div class="container add-credit-card settings bg-white">

    <h3 class="py-4"><i class="far fa-credit-card"></i> {{'pleaseAddCreditCard_1' | translate}}</h3>

    <div class="row flex-md-row-reverse justify-content-md-end gap-3">
        <div class="col-md-4">
            <h3 class="mt-0">{{'monthUsage' | translate}}</h3>
            <p>{{'base_price' | translate}} {{unit_price}}{{currencyCtrl.value.display}}/{{'month'| translate}}/{{'per_user'| translate}}.</p>

            <table class="table my-3 border rounded">
                <thead>
                <tr>
                    <th>{{'team_name' | translate}}</th>
                    <th>{{'team_size' | translate}}</th>
                    <th>Total</th>
                </tr>
                </thead>
                <tbody>
                @for(team of teams; track team.name){
                <tr>
                    <td data-cy="team_name"><a [routerLink]="['/setup/team', team.id]" target="_blank">{{team.name}}</a></td>
                    @if(!team.already_subscribed){
                        <td><a [routerLink]="['/setup/teammembers', team.id]" target="_blank">{{team.active_members_count}} {{'users' | translate}}</a></td>
                    <td>{{team.active_members_count * unit_price}}{{currencyCtrl.value.display}}</td>
                    }@else{
                    <td colspan="2">{{'already_existing_subscription' | translate}}</td>
                    }
                </tr>
                }
                @if(duplicated_members_count > 0){
                <tr>
                    <td>
                        <small>{{'duplicated_members' | translate}}</small>
                    </td>
                    <td>-{{duplicated_members_count}} {{'users' | translate}}</td>
                    <td>-{{duplicated_members_count * unit_price}}{{currencyCtrl.value.display}}</td>
                </tr>
                }
                <tr>
                    <td></td>
                    <td>
                        <small>{{'vat' | translate}} ({{vat_rate}}%)</small>
                    </td>
                    <td>
                        <small data-cy="vat-amount">{{vat_amount}}{{currencyCtrl.value.display}}</small>
                    </td>
                </tr>
                <tr>
                    <td><h4><strong>Total</strong></h4></td>
                    <td><h4><strong>{{total_active_members_count - duplicated_members_count}} {{'users' | translate}}</strong></h4></td>
                    <td><h4><strong>{{total_amount}}{{currencyCtrl.value.display}}/{{'month'| translate}}</strong></h4></td>
                </tr>
                </tbody>
            </table>
            <p></p>
            <p><a class="cursor-pointer" (click)="chat()"><i class="far fa-comment-alt-lines"></i> {{'chat_with_us' | translate}}</a> {{'another_payment_option_2' | translate}}</p>
        </div>

        <div class="col-md-6">
            <form name="billing_form" class="form-horizontal form-box" [formGroup]="billingForm" novalidate="" style="border: none" (ngSubmit)="submitPaymentForm()">
                <div class="form-box-header">
                    <h4>{{'choose_currency' | translate}}</h4>
                </div>

                <div class="form-box-content">
                    <fieldset [disabled]="loading" class="px-4">
                        <div class="form-group row py-4">
                            <label class="col-form-label col-md-4">{{'currency' | translate}}</label>
                            <div class="col-md-8">
                                <mat-button-toggle-group [formControl]="currencyCtrl" aria-label="Country">
                                    <mat-button-toggle data-cy="EUR" [value]="EuroCurrency" matTooltipPosition="above" matTooltip="EURO">EUR</mat-button-toggle>
                                    <mat-button-toggle data-cy="GBP" [value]="GBPCurrency" matTooltipPosition="above" matTooltip="Pound Sterling">GBP</mat-button-toggle>
                                    <mat-button-toggle data-cy="USD" [value]="USDCurrency" matTooltipPosition="above" matTooltip="US Dollar">US$</mat-button-toggle>
                                    <mat-button-toggle data-cy="AUD" [value]="AUDCurrency" matTooltipPosition="above" matTooltip="Australian Dollar">AU$</mat-button-toggle>
                                    <mat-button-toggle data-cy="CAD" [value]="CADCurrency" matTooltipPosition="above" matTooltip="Canadian Dollar">CA$</mat-button-toggle>
                                </mat-button-toggle-group>
                            </div>
                        </div>

                    </fieldset>
                </div>

                <div class="white-space"></div>

                <div class="form-box-header">
                    <h4>{{'billing_address' | translate}}</h4>
                </div>

                <div class="form-box-content pb-4">
                    <fieldset [disabled]="loading" class="px-4">

                        <div class="form-group py-3" [ngClass]="{ 'has-error' : nameCtrl.invalid && !nameCtrl.pristine }">
                            <label class="col-form-label" for="card_holder_name">
                                {{'card_holder_name' | translate}} *
                            </label>
                            <div>
                                <div class="input-group">
                                    <input type="text" id="card_holder_name" name="card_holder_name" [formControl]="nameCtrl" class="form-control">
                                    <span class="icon-addon"><i class="far fa-building"></i></span>
                                </div>
                                @if((nameCtrl.invalid && !nameCtrl.pristine)){
                                <small class="help-block text-danger">
                                    {{'card_holder_name_required' | translate}}
                                </small>
                                }
                            </div>
                        </div>

                        <div class="form-group py-3">
                            <div [ngClass]="{ 'has-error':  addressLine1Ctrl.invalid && !addressLine1Ctrl.pristine }">
                                <label class="col-form-label" for="addressLine1">
                                    {{'addressLine1' | translate}} *
                                </label>
                                <div>
                                    <div class="input-group">
                                        <input type="text" id="addressLine1" name="addressLine1" [formControl]="addressLine1Ctrl" class="form-control" required="">
                                        <span class="icon-addon"><i class="far fa-reorder"></i></span>
                                    </div>
                                    @if(addressLine1Ctrl.invalid && !addressLine1Ctrl.pristine){
                                    <small class="help-block text-danger">
                                        {{'addressLine_required' | translate}}
                                    </small>
                                    }
                                </div>
                            </div>
                            <label class="col-form-label" for="addressLine2">{{'addressLine2' | translate}}</label>
                            <div>
                                <div class="input-group">
                                    <input type="text" id="addressLine2" name="addressLine2" [formControl]="addressLine2Ctrl" class="form-control">
                                    <span class="icon-addon"><i class="far fa-reorder"></i></span>
                                </div>
                            </div>
                        </div>

                        <div class="form-group py-3 d-flex justify-content-between gap-3">
                            <div class="flex-grow-1" [ngClass]="{ 'has-error': postalcodeCtrl.invalid && !postalcodeCtrl.pristine }">
                                <label class="col-form-label" for="postalcode">
                                    {{'addressZip' | translate}} *
                                </label>

                                <div>
                                    <input type="text" id="postalcode" name="postalcode" [formControl]="postalcodeCtrl" class="form-control" required="">
                                    @if(postalcodeCtrl.invalid && !postalcodeCtrl.pristine){
                                    <small class="help-block text-danger">
                                        {{'postalcode_required' | translate}}
                                    </small>
                                    }
                                </div>
                            </div>

                            <div class="flex-grow-1" [ngClass]="{ 'has-error':  addressCityCtrl.invalid && !addressCityCtrl.pristine }">
                                <label class="col-form-label" for="addressCity">
                                    {{'addressCity' | translate}} *
                                </label>
                                <div>
                                    <input type="text" id="addressCity" name="addressCity" [formControl]="addressCityCtrl" class="form-control" required="">
                                    @if(addressCityCtrl.invalid && !addressCityCtrl.pristine){
                                    <small class="help-block text-danger">
                                        {{'city_required' | translate}}
                                    </small>
                                    }
                                </div>
                            </div>
                        </div>

                        <div class="form-group py-3 border-0">
                            <label class="col-form-label" for="country">
                                {{'country' | translate}} *
                            </label>
                            <div>
                                <div class="input-group">
                                    <mat-select id="country" class="form-select" [formControl]="selectedCountryCtrl">
                                        @for (country of countries;track country.value){
                                            <mat-option [value]="country">{{country.label}}</mat-option>
                                        }
                                    </mat-select>
                                    <span class="icon-addon"><i class="far fa-globe"></i></span>
                                </div>
                            </div>
                        </div>
                    </fieldset>
                </div>

                @if(within_eu){
                <div class="white-space"></div>

                <div class="form-box-header animate__animated animate__pulse" data-cy="vat">
                    <h4>{{'vat_number_title' | translate}}</h4>
                    <p>{{'vat_number_description' | translate}}
                        <a href="http://help.teammood.com/pricing-security-privacy-and-terms/subscribe-to-teammood/about-european-vat" title="Help" target="_blank">
                            ({{'why' | translate}}) <i class="far fa-sm fa-external-link"></i>
                        </a></p>
                </div>

                <div class="form-box-content animate__animated animate__pulse">
                    <fieldset [disabled]="loading" class="px-4">
                        <div [ngClass]="{ 'has-error':  vatNumberCtrl.value === '' && !vatNumberCtrl.pristine }">

                            <label class="col-form-label col-md-3" for="vat_number"><small>{{'vat_number' | translate}} *</small></label>

                            <div class="col-md-9">
                                <div class="input-group">
                                    <input type="text" id="vat_number" name="vat_number" class="form-control" placeholder="GB123456789" [formControl]="vatNumberCtrl">
                                    <span class="icon-addon"><i class="far fa-id-card"></i></span>
                                </div>
                                @if(vatNumberCtrl.value === null || vatNumberCtrl.value === ''){
                                <small class="help-block text-danger">
                                    {{'vat_number_required' | translate}}
                                </small>
                                }
                            </div>
                        </div>
                    </fieldset>
                </div>
                <div class="form-box-header animate__animated animate__pulse px-4">
                    <p>{{'no_vat' | translate}} <a href="https://vat-search.eu/" target="_blank"><i class="far fa-search"></i> {{'vat_search' | translate}}</a> {{ 'or' | translate}} <a class="cursor-pointer" (click)="chat()">{{'chat_with_us' | translate}}</a></p>
                </div>
                }


                <div class="white-space"></div>

                <div class="form-box-header d-flex justify-content-between align-items-center">
                    <div>
                        <h4>{{'upgradePremiumBillingSectionTitle' | translate}}</h4>
                        <p>
                            <small>{{'upgradePremiumBillingSubtitle' | translate}}</small>
                        </p>
                    </div>
                    <div>
                        <img class="img-responsive" src="/assets/images/lock.png">
                        <img class="img-responsive " src="/assets/images/stripe.png">
                    </div>
                </div>

                <fieldset [disabled]="loading" data-cy="stripe-credit-card">
                    <div class="d-flex ms-3 pt-3 px-5">
                        <img class="img-responsive card-img" src="/assets/images/visa.png">&nbsp;
                        <img class="img-responsive card-img" src="/assets/images/amex.png">&nbsp;
                        <img class="img-responsive card-img" src="/assets/images/mastercard.png">
                    </div>
                    <div class="form-group px-5">
                        <label class="col-form-label col-md-3" for="card-number">
                            {{'credit_card_management' | translate}}
                        </label>

                        <div class="col-md-9">
                            <div class="form-control">
                                <div id="card-number"></div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group pb-3 px-5">
                        <label class="col-form-label col-md-3" for="card-expiry">
                            {{'expiration_date' | translate}}
                        </label>

                        <div class="col-md-3">
                            <div class="form-control">
                                <div id="card-expiry"></div>
                            </div>
                        </div>

                        <label class="col-form-label col-md-3" for="card-cvc">
                            {{'cvc' | translate}}
                        </label>

                        <div class="col-md-3">
                            <div class="form-control">
                                <div id="card-cvc"></div>
                            </div>
                        </div>
                    </div>

                    <div class="form-group form-actions px-5">
                            <button class="btn btn-primary" type="submit" data-cy="submit-card" [disabled]="billingForm.invalid || !stripePaymentFormValid() || (within_eu && (!vatNumberCtrl.value || 0 === vatNumberCtrl.value.length))">
                                @if(loading){
                                <i class="far fa-sync fa-spin"></i>
                                <span>({{processing_step}}) {{'submit_upgrade_premium_loading' | translate}}</span>
                                } @else {
                                <span>{{'submit_upgrade_premium' | translate}}</span>
                                }
                            </button>
                    </div>
                </fieldset>
            </form>
        </div>
    </div>
</div>